'use strict';

/*
  EABasic Skin
  Copyright 2017 Expressive Analytics LLC.
*/

require("./main.scss")
